import { createRouter, createWebHistory } from 'vue-router';
import Cart from '../view/CartPage.vue';
import YingBi from '../view/YingBiPage.vue';
import GetYingBi from '../view/GetYingBiPage.vue';
import FenXiangGuan from '../view/FenXiangGuanPage.vue';
import PingLunHuiKui from '../view/PingLunHuiKuiPage.vue';
import Equipment from '../view/EquipmentListPage.vue';
import Wrong from '@/view/WrongPage.vue';
import StudyData from '@/view/StudyDataPage.vue';
import Usage from '@/view/UsagePage.vue';
import Privacy from '@/view/PrivacyPage.vue';
import Service from '@/view/ServicePage.vue';

import SubmitPinglunhuikui from '@/view/SubmitPinglunhuikui.vue';
import SubmitFenxiangguan from '@/view/SubmitFenxiangguan.vue';
import AdminLogin from '@/view/AdminLogin.vue';
import AdminPage from '@/view/AdminPage.vue';

let token = null; // 全局变量来存储token
const routes = [

  {
    path: '/',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/yingbi',
    name: 'YingBi',
    component: YingBi
  },

  {
    path: '/getyingbi',
    name: 'GetYingBi',
    component: GetYingBi
  },
  {
    path: '/fenxiangguan',
    name: 'FenXiangGuan',
    component: FenXiangGuan
  },
  {
    path: '/pinglunhuikui',
    name: 'PingLunHuiKui',
    component: PingLunHuiKui
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: Equipment
  },
  {
    path: '/wrong',
    name: 'Wrong',
    component: Wrong
  },
  {
    path: '/studydata',
    name: 'StudyData',
    component: StudyData
  },
  {
    path: '/usage',
    name: 'Usage',
    component: Usage
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/service',
    name: 'Service',
    component: Service
  },
  {
    path: '/submit/pinglunhuikui',
    name: 'SubmitPinglunhuikui',
    component: SubmitPinglunhuikui
  },
  {
    path: '/submit/fenxiangguan',
    name: 'SubmitFenxiangguan',
    component: SubmitFenxiangguan
  },
  {
    path: '/jingxin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },

  {
    path: '/jingxin/admin',
    name: 'AdminPage',
    component: AdminPage
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {

  if (to.path === '/wrong') {
    next();
    return;
  }


  // 管理后台登录校验
  if (to.name === 'AdminPage') {
    const isAdmin = localStorage.getItem('isAdmin');
    const expire = localStorage.getItem('adminExpire');
    const now = Date.now();
    if (isAdmin === '1' && expire && now < Number(expire)) {
      next();
    } else {
      // 清除过期标志
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('adminExpire');
      next({ name: 'AdminLogin' });
      return;
    }
  }







  if (!token) {
    try {
      token = await getTokenFromAppPreferences();
    } catch (error) {
      console.error("Error fetching token:", error);
      return next('/wrong');
    }
  }






  
  if (token) {
    next();
  } else {
    next('/wrong');
  }
});



// 模拟从安卓 AppPreferences 获取 token 的函数
async function getTokenFromAppPreferences() {
  // 这里需要实现从安卓 AppPreferences 获取 token 的逻辑
  // 例如：通过调用安卓接口获取 token
  // return new Promise((resolve,reject) => {
  //   if (window.AndroidInterface && typeof window.AndroidInterface.getToken === 'function') {
  //     const token = window.AndroidInterface.getToken();
  //     resolve(token);
  //     console.log('token:', token);
      
  //   } else {
  //     reject('Android interface not available');
  //   }
    
  // });

  return 'token';//模拟获取token

  //抛出异常
  // throw new Error('Android interface not available');


}






export default router;